import { TARIFFS_LOAD } from './actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';
import { fromJS } from 'immutable';

import api from '../../apiSingleton';

export function loadTariffs () {
  return (dispatch, getState) => {
    const domain = getState().getIn(['domain', 'regionId']) || null;

    dispatch({
      type: TARIFFS_LOAD + START
    });

    return api.tariffs.fetchTariffs(domain)
      .then((data) => dispatch({
        type: TARIFFS_LOAD + SUCCESS,
        items: fromJS(data)
      }))
      .catch((err) => dispatch({
        type: TARIFFS_LOAD + ERROR,
        payload: err.message
      }));
  };
}



// WEBPACK FOOTER //
// ./src/app/Tariffs/actions.js